import { call, put, takeLatest, takeEvery, delay, select } from 'redux-saga/effects';

import {
	getOrdersBtc,
	getOrdersBtcSuccess,
	getOrdersBtcFailure,
	getOrderBtcById,
	getOrderBtcByIdSuccess,
	getOrderBtcByIdFailure,
	createManyOrderBtc,
	createManyOrderBtcSuccess,
	createManyOrderBtcFailure,
	createOrderBtc,
	createOrderBtcSuccess,
	createOrderBtcFailure,
	getPackageSizes,
	finalizeOrderBtc,
	finalizeOrderBtcSuccess,
	finalizeOrderBtcFailure,
	unfullfillOrderBtc,
	unfullfillOrderBtcSuccess,
	unfullfillOrderBtcFailure,
	getPackageSizesFailure,
	getPackageSizesSuccess,
	getOrderStatuses,
	getOrderStatusesSuccess,
	getOrderStatusesFailure,
	getAccountantsBtcByClientId,
	getAccountantsBtcByClientIdFailure,
	getAccountantsBtcByClientIdSuccess,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
} from '.';

import orderBtcService from '../../../services/OrderBtcService';

function* rootSaga() {
	yield takeLatest(getOrdersBtc, getOrdersBtcSaga);
	yield takeLatest(getOrderBtcById, getOrderBtcByIdSaga);
	yield takeLatest(getAccountantsBtcByClientId, getAccountantsBtcByClientIdSaga);
	yield takeLatest(createOrderBtc, createOrderBtcSaga);
	yield takeLatest(createManyOrderBtc, createManyOrderBtcSaga);
	yield takeEvery(finalizeOrderBtc, finalizeOrderBtcSaga);
	yield takeEvery(unfullfillOrderBtc, unfullfillOrderBtcSaga);
	yield takeLatest(getPackageSizes, getPackageSizesSaga);
	yield takeLatest(getOrderStatuses, getOrderStatusesSaga);
	yield takeLatest(downloadCsv, downloadCsvSaga);
}

function* getOrdersBtcSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtcService.getAll, payload);
		yield put(getOrdersBtcSuccess(response));
	} catch (error) {
		yield put(getOrdersBtcFailure(error));
	}
}

function* getAccountantsBtcByClientIdSaga({ payload }) {
	const clientId = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtcService.getAccountantsByClientId, clientId);
		yield put(getAccountantsBtcByClientIdSuccess(response));
	} catch (error) {
		yield put(getAccountantsBtcByClientIdFailure(error));
	}
}

function* getOrderBtcByIdSaga({ payload }) {
	const orderId = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtcService.getById, orderId);
		yield put(getOrderBtcByIdSuccess(response));
	} catch (error) {
		yield put(getOrderBtcByIdFailure(error));
	}
}

function* createManyOrderBtcSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtcService.createMany, payload);
		yield put(createManyOrderBtcSuccess(response));
	} catch (error) {
		yield put(createManyOrderBtcFailure(error));
	}
}

function* createOrderBtcSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtcService.create, payload);
		yield put(createOrderBtcSuccess(response));

		// Refreshing the ordersBtc list since we created one:
		const tableParams = yield select(({ ordersBtc }) => ordersBtc.ordersBtc.tableParams);
		yield put(getOrdersBtc(tableParams));
	} catch (error) {
		yield put(createOrderBtcFailure(error));
	}
}

function* finalizeOrderBtcSaga({ payload }) {
	const { orderBtcId: id, data: orderBtcForm } = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtcService.finalize, id, orderBtcForm);
		yield put(finalizeOrderBtcSuccess(response));

		// Refreshing the ordersBtc list since we finalized one:
		const tableParams = yield select(({ ordersBtc }) => ordersBtc.ordersBtc.tableParams);
		yield put(getOrdersBtc(tableParams));

		// Refreshing the orderBtc details since we finalized one:
		const selectedOrder = yield select(({ ordersBtc }) => ordersBtc.orderBtc.data);
		if (selectedOrder) {
			if (id == selectedOrder.id) {
				yield put(getOrderBtcById(id));
			}
		}
	} catch (error) {
		yield put(finalizeOrderBtcFailure(error));
	}
}

function* unfullfillOrderBtcSaga({ payload }) {
	const { orderBtcId: id, data: orderBtcForm } = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtcService.unfullfill, id, orderBtcForm);
		yield put(unfullfillOrderBtcSuccess(response));

		// Refreshing the ordersBtc list since we unfullfilled one:
		const tableParams = yield select(({ ordersBtc }) => ordersBtc.ordersBtc.tableParams);
		yield put(getOrdersBtc(tableParams));

		// Refreshing the orderBtc details since we unfullfilled one:
		const { id: selectedOrderId } = yield select(({ ordersBtc }) => ordersBtc.orderBtc.data);
		if (id == selectedOrderId) {
			yield put(getOrderBtcById(id));
		}
	} catch (error) {
		yield put(unfullfillOrderBtcFailure(error));
	}
}

function* getPackageSizesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtcService.getPackageSizes);
		yield put(getPackageSizesSuccess(response));
	} catch (error) {
		yield put(getPackageSizesFailure(error));
	}
}

function* getOrderStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtcService.getOrderStatuses);
		yield put(getOrderStatusesSuccess(response));
	} catch (error) {
		yield put(getOrderStatusesFailure(error));
	}
}

function* downloadCsvSaga({ payload }) {
	try {
		yield delay(300);
		yield call(orderBtcService.downloadCsv, payload);
		yield put(downloadCsvSuccess());
	} catch (error) {
		yield put(downloadCsvFailure(error));
	}
}

export default rootSaga;
